import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const PresaleTimer = ({ roundData, timeshow, setTimeshow, refresh }) => {
  const { t } = useTranslation();

  const [day, setDay] = useState(0);
  const [hour, setHour] = useState(0);
  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);
  const [day1, setDay1] = useState(0);
  const [hour1, setHour1] = useState(0);
  const [min1, setMin1] = useState(0);
  const [sec1, setSec1] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const time = roundData.startTime;
      const diff = time - now;
      if (diff <= 0) {
        clearInterval(interval);
        setTimeshow(true);
        refresh();
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((diff % (1000 * 60)) / 1000);
      setDay1(days);
      setHour1(hours);
      setMin1(mins);
      setSec1(secs);
    }, 1000);
    return () => clearInterval(interval);
  }, [roundData.startTime]);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const time = roundData.endTime;
      const diff = time - now;
      if (diff <= 0) {
        clearInterval(interval);
        setTimeshow(true);
        refresh();
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((diff % (1000 * 60)) / 1000);
      setDay(days);
      setHour(hours);
      setMin(mins);
      setSec(secs);
    }, 1000);
    return () => clearInterval(interval);
  }, [roundData.endTime]);

  const safe = (v) => (Number.isFinite(v) ? v : 0);
  return (
    <>
      <div className="timer-parent">
        <h6 className="main-head">
          {!timeshow ? <>{t("Process-t13")}</> : <>{t("Process-t10")}</>}
        </h6>
        {!timeshow ? (
          <div className="timer">
            <div className="text">
              <h6>{day1}</h6>
              <p>{t("Days")}</p>
            </div>
            <span>:</span>
            <div className="text">
              <h6>{hour1}</h6>
              <p>{t("Hour")}</p>
            </div>
            <span>:</span>
            <div className="text">
              <h6>{min1}</h6>
              <p>{t("Min")}</p>
            </div>
            <span>:</span>
            <div className="text">
              <h6>{sec1}</h6>
              <p>{t("Sec")}</p>
            </div>
          </div>
        ) : (
          <div className="timer">
            <div className="text">
              <h6>{day}</h6>
              <p>{t("Days")}</p>
            </div>
            <span>:</span>
            <div className="text">
              <h6>{hour}</h6>
              <p>{t("Hour")}</p>
            </div>
            <span>:</span>
            <div className="text">
              <h6>{min}</h6>
              <p>{t("Min")}</p>
            </div>
            <span>:</span>
            <div className="text">
              <h6>{sec}</h6>
              <p>{t("Sec")}</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PresaleTimer;
